import { AudienceTargetingsValue } from './audienceTargetings';
import { Domain, GroupBaseInfo, RetargetingConditionRule } from './domain';
import { CryptaInterestTypeWeb } from './graphql-grid';

export interface UserProfileRetargetingCondition {
    id: string;
    name: string;
    conditionRules: UserProfileRetargetingConditionRule[];
    audienceTargetings: AudienceTargetingsValue;
}

export interface UserProfileRetargetingConditionRule {
    interestType?: CryptaInterestTypeWeb;
    goals: UserProfileRetargetingConditionRuleGoal[];
    type: UserProfileRetargetingConditionRuleType;
}

export enum UserProfileRetargetingConditionRuleType {
    ALL = 'ALL',
    NOT = 'NOT',
    OR = 'OR'
}

export interface UserProfileRetargetingConditionRuleGoal {
    id: string;
    type: UserProfileRetargetingConditionGoalType;
    time: number;
}

export enum UserProfileRetargetingConditionGoalType {
    AB_SEGMENT = 'AB_SEGMENT',
    AUDIENCE = 'AUDIENCE',
    AUDIO_GENRES = 'AUDIO_GENRES',
    BEHAVIORS = 'BEHAVIORS',
    ECOMMERCE = 'ECOMMERCE',
    FAMILY = 'FAMILY',
    GOAL = 'GOAL',
    INTERESTS = 'INTERESTS',
    SEGMENT = 'SEGMENT',
    SOCIAL_DEMO = 'SOCIAL_DEMO'
}

export interface UserProfile extends Domain {
    id: string;
    name: string;
    userProfileConditions: UserProfileCondition[];
    group: GroupBaseInfo;
    priceContext: number;
    metrikaAudienceGoals: RetargetingConditionRule[];
    isPriceContextEnabled: boolean;
    isEditable: boolean;
}

export interface UserProfileCondition {
    key: string;
    values: string[];
    type: UserProfileRetargetingConditionGoalType;
    interestType: CryptaInterestTypeWeb | null;
}
